import HeroCollectionWrapper from '@/components/HeroCollectionWrapper'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import { isCollectionOfIMediaCard, isHomepageOrder } from '@/shared-utils/content-model-type-guards'
import { MediaCardCollection } from '@pcln/marketing'
import { Hide } from 'pcln-design-system'
import MediaCardComponent from '../Promos/MediaCard/MediaCardComponent'
import { StyledFlex } from './ContentfulOrderWrapper.styled'

type ContentfulOrderedItem = 'heroCollection' | 'topDeals'

function ContentfulItem({ name }: { name: ContentfulOrderedItem }) {
  const mediaCardsTopDealsData = useContentfulVariation('mediaCardsTopDeals', isCollectionOfIMediaCard)

  if (name === 'heroCollection') {
    return <HeroCollectionWrapper />
  }
  return (
    <Hide md>
      {mediaCardsTopDealsData ? (
        <MediaCardCollection collection={mediaCardsTopDealsData} cardNode={MediaCardComponent} />
      ) : null}
    </Hide>
  )
}

export default function ContentfulOrderWrapper() {
  const { firstItem = 'heroCollection', secondItem = 'topDeals' } =
    useContentfulVariation('homepageOrder', isHomepageOrder) ?? {}
  return (
    <StyledFlex flexDirection='column'>
      <ContentfulItem name={firstItem} />
      <ContentfulItem name={secondItem} />
    </StyledFlex>
  )
}
